/**
 * Trans (T) Component — translates any English text automatically.
 *
 * Uses the English text directly as the translation key.
 * If no translation found, returns English as fallback.
 *
 * Usage:
 *   <T>Save</T>       → "Enregistrer" (French)
 *   <T>Dashboard</T>  → "Tableau de bord" (French)
 */
import { createContext, useContext } from "react";

// Default no-op t function — just returns text as-is
const defaultT = (str, params = {}) => {
  if (!str) return str;
  if (!params || Object.keys(params).length === 0) return str;
  return str.replace(/\{(\w+)\}/g, (_, p) => params[p] !== undefined ? String(params[p]) : `{${p}}`);
};

const I18nTContext = createContext(defaultT);

export function useT() {
  return useContext(I18nTContext);
}

export function TProvider({ children, t }) {
  return <I18nTContext.Provider value={t || defaultT}>{children}</I18nTContext.Provider>;
}

/**
 * Translate children text to current language.
 * Outside TProvider, returns English text as-is.
 */
export default function T({ children, ...params }) {
  const tFn = useContext(I18nTContext);
  const text = typeof children === "string" ? children : children?.join?.("") || "";
  if (!text) return <>{children}</>;
  return <>{tFn(text, params)}</>;
}
